import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Generic hook to check if the current pathname matches any of the given paths
 * @param paths - Array of pathnames to match against
 */
export function useIsPathMatch(paths: string[]): boolean {
  const location = useLocation();

  return useMemo(() => {
    return paths.includes(location.pathname);
  }, [location.pathname, paths]);
}

/**
 * Specific hook for checking if dashboard is embedded
 */
export function useIsDashboardEmbedded(): boolean {
  return useIsPathMatch(['/health-assistant', '/health-assistant/']);
}
